import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "@/_services/storage/index.js";

function getBankTransactionColumns({
  FXCurrency,
  isBankAccountCurrencyTheSameAsCompanyCurrency,
  isSundryTransaction = false,
  onCopyClick,
} = {}) {
  return [
    {
      screenField: "Date",
      gridDataField: "Date",
      filterDataField: "Date",
      showInColumnChooser: true,
      filterIndex: 1,
      allowSorting: true,
      maxWidth: ColumnWidth.Date.minWidth,
    },
    {
      screenField: "FXAmount",
      filterIndex: 0,
      type: "Integer",
      filterDataField: "FXAmountAbs",
      visible: false,
      showInColumnChooser: false,
    },
    {
      screenField: "Account",
      gridDataField: "BankAccountSearchText",
      dataField: "BankAccountSearchText",
      label: "Account",
      allowHiding: false,
      minWidth: ColumnWidth.TransactionAccount.minWidth,
      width: "auto",
      showInColumnChooser: true,
      cellTemplate: "RecordTwoLines",
      exportFields: undefined,
      filterIndex: 8,
      filterDataField: "BankAccountSearchText",
      dataType: "string",
      type: "Text",
      cellTemplateRecord: {
        primary: [
          {
            dataField: "BankAccountName",
          },
        ],
        secondary: [
          {
            dataField: "BsbNoAndBankAccountNo",
          },
        ],
      },
    },
    {
      screenField: "TradingPartner",
      cellTemplate: undefined,
      cellTemplateRecord: undefined,
      exportFields: undefined,
      label: "Partner",
      allowSorting: true,
      showInColumnChooser: true,
      filterIndex: 3,
      filterDataField: "TradingPartner",
      type: "Text",
      minWidth: ColumnWidth.BankAccount.minWidth,
    },
    {
      screenField: "PayeeName",
      label: "Payee/Payer",
      dataField: "TradingPartnerName", // in CashBookView this is the field that is used to display the payee/payer name
      type: "Text",
      filterLabel: "Payee/Payer",
      filterDataField: "TradingPartnerName", // in CashBookView this is the field that is used to filter the payee/payer name
      allowSorting: true,
      filterIndex: 4,
      minWidth: ColumnWidth.BankAccount.minWidth,
    },
    {
      screenField: "Reference",
      dataField: "Reference",
      visible: false,
      showInColumnChooser: false,
      filterIndex: 4,
      filterDataField: "Reference",
      filterLabel: "Reference",
      type: "Text",
    },
    {
      screenField: "Customer",
      visible: false,
      showInColumnChooser: false,
      filterIndex: 5,
    },
    {
      screenField: "Supplier",
      filterDataField: "SupplierCode",
      visible: false,
      showInColumnChooser: false,
      filterIndex: 6,
    },
    {
      screenField: "TransactionType",
      dataField: "TransactionType",
      filterDataField: "TransactionType",
      filterIndex: 7,
      label: "Type ",
      allowSorting: true,
      showInColumnChooser: true,
      visible: true,
      minWidth: ColumnWidth.PaymentType.minWidth,
      maxWidth: ColumnWidth.PaymentType.minWidth,
      dataSourceConfig: {
        data: isSundryTransaction ? ["Sundry Payment",
          "Sundry Receipt"] : [
          "Supplier Payment",
          "Customer Receipt",
          "Sundry Payment",
          "Sundry Receipt",
        ],
      },
    },
    {
      screenField: "TransactionCode",
      width: 75,
      dataField: "ComputedTransaction",
      label: "Transaction",
      showInColumnChooser: true,
      visible: true,
      allowSearch: true,
      allowSorting: true,
      hyperlink: {
        url: "",
        dataField: "ComputedTransaction",
        gridUrlDataFields: ["TransactionType"],
        gridUrlConditions: [
          {
            values: [{ TransactionType: "Customer Receipt" }],
            url: `customer-receipt/review/__ID__`,
          },
          {
            values: [{ TransactionType: "Sundry Receipt" }],
            url: `sundry-receipt/__ID__`,
          },
          {
            values: [{ TransactionType: "Supplier Payment" }],
            url: `supplier-payment/review/__ID__`,
          },
          {
            values: [{ TransactionType: "Sundry Payment" }],
            url: `sundry-payment/__ID__`,
          },
        ],
        target: "_blank",
      },
      filterIndex: 0,
      filterDataField: "ComputedTransaction",
      dataType: "string",
      type: "Text",
    },
    {
      screenField: "Reference",
      label: "Reference",
      dataField: "Reference",
      visible: true,
      showInColumnChooser: true,
      minWidth: ColumnWidth.PaymentReference.minWidth,
      width: ColumnWidth.PaymentReference.minWidth,
    },
    {
      screenField: "Currency",
      cellTemplate: null,
      cellTemplateRecord: undefined,
      gridDataField: "CurrencyCode",
      exportFields: undefined,
      width: 70,
      minWidth: 70,
      filterIndex: 9,
    },
    {
      screenField: "ExchangeRate",
      label: `FX Rate`,
      visible: !isBankAccountCurrencyTheSameAsCompanyCurrency,
      minWidth: ColumnWidth.ExchangeRate.minWidth,
      maxWidth: ColumnWidth.ExchangeRate.minWidth,
      allowSearch: false,
    },
    {
      screenField: "FXBalance",
      dataField: "FXSpent",
      visible: !isBankAccountCurrencyTheSameAsCompanyCurrency,
      format: "Decimal-16-2",
      label: `Spent (${FXCurrency}) `,
      allowSorting: true,
      showInColumnChooser: true,
      allowSearch: false,
      minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
      maxWidth: ColumnWidth.Price2DecimalPoints.width,
    },
    {
      screenField: "FXBalance",
      dataField: "Spent",
      format: "Decimal-16-2",
      label: `Spent (Base Currency)`,
      allowSorting: true,
      showInColumnChooser: true,
      visible: true,
      allowSearch: false,
      minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
      maxWidth: ColumnWidth.Price2DecimalPoints.width,
    },
    {
      screenField: "FXAmount",
      dataField: "FXReceived",
      label: `Received (${FXCurrency}) `,
      allowSorting: true,
      showInColumnChooser: true,
      minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
      maxWidth: ColumnWidth.Price2DecimalPoints.width,
      visible: !isBankAccountCurrencyTheSameAsCompanyCurrency,
      allowSearch: false,
    },
    {
      screenField: "FXAmount",
      dataField: "Received",
      label: `Received (Base Currency)`,
      allowSorting: true,
      showInColumnChooser: true,
      minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
      maxWidth: ColumnWidth.Price2DecimalPoints.width,
      visible: true,
      allowSearch: false,
    },
    {
      screenField: "DateCreated",
      dataField: "DateCreated",
      filterDataField: "DateCreated",
      filterIndex: 2,
      label: "Date Created",
      allowSorting: true,
      showInColumnChooser: true,
      visible: false,
      sortOrder: "desc",
      maxWidth: ColumnWidth.DateCreated.width,
    },
    {
      screenField: "CreatedBy",
      dataField: "CreatedBy",
      label: "Created By",
      allowSorting: true,
      showInColumnChooser: true,
      visible: true,
      maxWidth: ColumnWidth.Name.width,
    },
    {
      screenField: "Narration",
      customizeText: (e) => {
        if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
        else return "";
      },
      encodeHtml: false,
      cellTemplate: (data, info) => {
        return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
      },
      visible: false,
      filterIndex: 4,
      filterDataField: "Narration",
      filterLavel: "Narration",
      type: "Text",
    },
    {
      screenField: "OrderStatus",
      dataField: "FriendlyStatus",
      label: "Status",
      allowSorting: true,
      showInColumnChooser: true,
      visible: true,
      filterIndex: 8,
      filterDataField: "FriendlyStatus",
      dataSourceConfig: {
        data: ["Reconciled", "Unpresented"],
      },
    },
    {
      screenField: "GridRecordEllipsisMenu",
      cssClass: "padding-7",
      allowSearch: false,
      showInColumnChooser: false,
      ellipsisMenu: {
        itemAction: (data) => {
          return [
            {
              menuText: "Copy",
              data: data,
              clickAction: onCopyClick,
              disabled:
                !(data.data.TransactionType === "Sundry Payment" ||
                  data.data.TransactionType === "Sundry Receipt"),
            },
          ];
        },
        keyExpr: "menuText",
        displayExpr: "menuText",
      },
      makeDisabled: (data) => {
        return !FeatureStorage.checkPermission("BankTransactions", "create") || !(data.data.TransactionType === "Sundry Payment" ||
          data.data.TransactionType === "Sundry Receipt");
      },
    },
  ];
}

export { getBankTransactionColumns };
